import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux'
import store from './store.js';
import { HashRouter } from 'react-router-dom'
import ScrollToTop from './ScrollToTop';
import { captureJweFromUrl, installJweInterceptor, installJweExpiredInterceptor } from './service/JweSession';

// Handoff EA legacy -> NEA : on capte le JWE présent dans l'URL et on l'installe
// sur les appels /api/public et /api/private avant le premier rendu.
captureJweFromUrl();
installJweInterceptor();
installJweExpiredInterceptor();

ReactDOM.render(
    <HashRouter>
        <ScrollToTop>
            <Provider store={store}>
                <App></App>
            </Provider>
        </ScrollToTop>
    </HashRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();